import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { ItemMasterPopup } from './ItemMasterTable';
import moment from 'moment';
import { saveAs } from "file-saver";
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import CommonServices from '../../../services/axiosServices/apiServices/CommonServices';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class ItemMaster extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.commonServices = new CommonServices();
        this.drawingFileRef = React.createRef();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            itemObject: {
                idItem: 0,
                updateStatus: 0,
                srNo: "",
                itemCode: "",
                itemGrpId: "",
                itemType: "RAW MATERIAL",
                //itemTypeId: 1,
                types: [
                    {
                        value: 1,
                        label: "RAW MATERIAL"
                    },
                    {
                        value: 2,
                        label: "FINISHED GOODS"
                    },
                    {
                        value: 3,
                        label: "SEMI FINISHED"
                    },
                    {
                        value: 4,
                        label: "SCRAP MATERIAL"
                    },
                ],
                itemCategoryList: [],
                allItemCategoryList: [],
                idItemCategory: 0,
                itemCategoryNameList: [],
                itemName: "",
                displayName: "",
                shortCode: "",
                itemUnitList: [],
                idUnit: "",
                searchText: "",
                materialList: [],
                idMaterial: 0,
                hsnCode: "",
                itemSizeList: [],
                idProductSize: "",
                openingStock: "",
                openingStockDate: "",
                currentStock: "",
                itemWeight: "",
                minLevel: "",
                maxLevel: "",
                orderQty: "",
                lockedQty: "",
                itemRate: "",
                costingRate: "",
                purchaseRate: "",
                jobWorkRate: "",
                taxStructureList: [],
                idTaxStructure: 0,
                rateOn: "",
                rateOnList: [
                    {
                        value: 1,
                        label: "NOS"
                    },
                    {
                        value: 2,
                        label: "KG"
                    },
                ],
                drawingNo: "",
                drawingFile: "",
                location: "",
                remarks: "",
                manage: "",
                eDate: "",
                isUpdated: "",
                updatedDate: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                itemName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "item name"
                        ),
                    },
                ],
                idUnit: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "item unit"
                        ),
                    },
                ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
            // this.getMasterExpenseAccGroupCount();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getItemMasterSelectbyID(event.data.idItem);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.itemObject;
        if (name === "manage") {
            details.manage = !details.manage;
        } else {
            details[name] = value;
        }
        //details[name] = value;
        this.setState({ itemObject: details });
    }

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let itemObject = this.state.itemObject;
        itemObject.idItem = 0;
        itemObject.updateStatus = 0;
        itemObject.eDate = "";
        itemObject.srNo = "";
        itemObject.itemCode = "";
        itemObject.itemGrpId = "";
        itemObject.itemType = "";
        //itemObject.itemTypeId = 1;
        //itemObject.types = [],
        //itemObject.itemCategoryList = [];
        itemObject.idItemCategory = 0;
        itemObject.itemName = "";
        itemObject.displayName = "";
        itemObject.shortCode = "";
        //itemObject.itemUnitList = [];
        itemObject.idUnit = "";
        itemObject.searchText = "";
        //itemObject.materialList = [];
        itemObject.idMaterial = 0;
        itemObject.hsnCode = "";
        //itemObject.itemSizeList = [];
        itemObject.idProductSize = "";
        itemObject.openingStock = "";
        itemObject.openingStockDate = "";
        itemObject.currentStock = "";
        itemObject.itemWeight = "";
        itemObject.minLevel = "";
        itemObject.maxLevel = "";
        itemObject.orderQty = "";
        itemObject.lockedQty = "";
        itemObject.itemRate = "";
        itemObject.costingRate = "";
        itemObject.purchaseRate = "";
        itemObject.jobWorkRate = "";
        //itemObject.taxStructureList = [];
        itemObject.idTaxStructure = 0;
        itemObject.rateOn = "";
        itemObject.drawingNo = "";
        itemObject.drawingFile = "";
        itemObject.location = "";
        itemObject.remarks = "";
        itemObject.manage = "";
        itemObject.isUpdated = "";
        itemObject.updatedDate = "";
        this.setState({
            itemObject: itemObject,
            validState: validState
        }, () => {
            if (this.drawingFileRef.current) {
                this.drawingFileRef.current.value = null;
            }
            this.filterItemCategoryList();
            this.getMasterDropdownData();
        });
    }

    getMasterDropdownData = () => {
        let request = {
            idCompany: this.state.idCompany,
            idCompanyDivision: 0,
        }
        this.masterEntryServices.getMasterDropdownData(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.itemObject;
                let count = allData.filter(item => item.identitys === 'CountOfMasterItem');
                data.srNo = count[0].count > 0 ? (count[0].count + 1) : (0 + 1);
                this.setState({
                    itemObject: data
                });
            }
        });
    }

    handleChangeFroDropdown = (event, name) => {
        //debugger;
        let details = this.state.itemObject;
        let value = event.value;
        if (name === 'rateOn' || name === 'itemType') {
            details[name] = event.label;
        } else {
            details[name] = value;
        }
        this.setState({ itemObject: details }, () => {
            if (name === 'itemType' || name === 'itemGrpId') {
                this.filterItemCategoryList();
            }
            else if (name === 'idItemCategory') {
                this.getMaster_ItemSelectForAutobyIdCategory()
            }
        });
    }

    filterItemCategoryList = () => {
        let data = this.state.itemObject;
        let masterList = data.allItemCategoryList || [];
        let filtered = masterList;

        if (data.itemType) {
            filtered = filtered.filter(item => item.name2 === data.itemType);
        }
        if (data.itemGrpId) {
            const selectedGroup = (data.itemGroupList || []).find(g => g.value === data.itemGrpId);
            if (selectedGroup) {
                filtered = filtered.filter(item => item.name3 === selectedGroup.label);
            }
        }

        const stillValid = data.idItemCategory && filtered.some(c => c.value === data.idItemCategory);
        data.itemCategoryList = filtered;
        if (!stillValid) {
            data.idItemCategory = 0;
        }
        this.setState({ itemObject: data });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.getAllDropdownForStockMaster();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    getAllDropdownForStockMaster = () => {
        this.masterEntryServices.getAllDropdownForStockMaster(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode === 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.itemObject;
                data.itemGroupList = allData.filter(item => item.source === 'ItemGroup'); //designations.map((p) => ({ value: p.id, label: p.name }));
                data.allItemCategoryList = allData.filter(item => item.source === 'Master_ItemCategory');
                data.itemCategoryList = data.allItemCategoryList;
                data.itemUnitList = allData.filter(item => item.source === 'MasterUnit');
                data.materialList = allData.filter(item => item.source === 'Material');
                data.itemSizeList = allData.filter(item => item.source === 'ProductSize');
                data.taxStructureList = allData.filter(item => item.source === 'TaxStructure');

                // let partyCode = allData.filter(item => item.source === 'PartyAccountCount');
                // data.partyCode = partyCode?.[0].value > 0 ? (partyCode?.[0].value + 1) : (0 + 1);

                this.setState({
                    itemObject: data
                }, () => {
                    //this.usp_Master_EmployeeSelect()
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    getMaster_ItemCategorySelectbyItemType = () => {
        let request = [
            this.state.itemObject.itemType,
            this.state.idCompany
        ];
        this.masterEntryServices.getMaster_ItemCategorySelectbyItemType(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = this.state.itemObject;
                let itemCategoryList = response.responseItem.responseContent;
                data.itemCategoryList = itemCategoryList.map((p) => ({ value: p.idItemCategory, label: p.itemCategory }));
                this.setState({
                    itemObject: data
                });
            }
        });
    }

    getMaster_ItemSelectForAutobyIdCategory = () => {
        let request = [
            this.state.idCompany,
            this.state.itemObject.idItemCategory
        ];
        this.masterEntryServices.getMaster_ItemSelectForAutobyIdCategory(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = this.state.itemObject;
                //let itemCategoryNameList = response.responseItem.responseContent;
                //data.itemCategoryNameList = itemCategoryNameList.map((p) => ({ value: p.idItemCategory, label: p.itemCategory }));
                this.setState({
                    itemObject: data
                });
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Item Master",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idItem"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            // valueFormatter: key.includes("date") || key.includes("invoiceDate")
                            //   ? (params) => {
                            //     if (!params.value) return "";
                            //     return moment(params.value).format("DD-MM-YYYY");
                            //   }
                            //   : undefined,
                            //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                        }));
                        //const priorityColumn = "bankName"; // Replace with the actual column name
                        //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
                        //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
                        //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

                        // const updatedColDefs = [
                        //   ...pinnedColumns,
                        //   ...(priorityColDef ? [priorityColDef] : []),
                        //   ...otherColumns,
                        // ];
                        var colName = dynamicColDefs[0].field;
                        // let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs, //updatedColDefs,
                            caption: "Item Master",
                            colName: colName
                        }, () => {
                            //this.procSelectAllRecord2GridviewSP(id, "Advance Withdraw");
                            //this.getAllDropdownForEmployeeMaster();
                            this.setPermissions(permissions);
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.05,
            "itemGroup": window.innerWidth * 0.12,
            "itemCategory": window.innerWidth * 0.12,
            "itemType": window.innerWidth * 0.1,
            "itemName": window.innerWidth * 0.2,
            "hsnCode": window.innerWidth * 0.1,
            "unit": window.innerWidth * 0.05,
            "itemSize": window.innerWidth * 0.13,
            "rate": window.innerWidth * 0.06,
            "weight": window.innerWidth * 0.05,
            "rateOn": window.innerWidth * 0.05,
            "drawingNo": window.innerWidth * 0.12,
            "location": window.innerWidth * 0.08,
            "itemRate": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    onFileChange = (event, identity) => {
        //debugger
        const file = event.target.files[0];
        // if (identity === "Upload_Certificate") {
        if (
            file &&
            (file.type === "image/jpeg" ||
                file.type === "image/png" ||
                file.type === "application/pdf" ||
                file.type === "application/pdf" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/msexcel" ||
                file.type === "application/vnd.ms-excel")
        ) {
            let uploadFile = { ...this.state.resFile };
            uploadFile.filename = file.name;
            uploadFile["file"] = file;
            uploadFile.storagePath = identity;
            //let detail = { ...this.state.partnerConsultantDetails };
            //detail.brochureFilePath = file.name;
            this.commonServices.uploadPDF(uploadFile).then((response) => {
                if (response != null) {
                    let detail = this.state.itemObject;
                    if (identity === 'DrawingFile') {
                        detail.drawingFile = response.fileName;
                    }
                    //  else if (identity === 'Sign') {
                    //     detail.signFileName = response.fileName;
                    // } else if (identity === 'Header') {
                    //     detail.headerImage = response.fileName;
                    // }
                    this.setState({ itemObject: detail });
                    this.SwalServices.Success("Uploaded");
                }
                else {
                    this.SwalServices.Error(response.message);
                }
            })
        }
        else {
            this.SwalServices.Error("Please select only Image!");
        }
        // }      
    };

    getFiles = (type, Filepath) => {
        if (Filepath) {
            let request = [
                type,
                Filepath,
            ];
            this.commonServices.getFiles(request).then((response) => {
                if (response.data !== null && response.status === 200) {
                    var formattedDate = moment(new Date()).format("DDMMYYYYHHmmss");
                    var filename = "";
                    filename = `${type}${formattedDate}`;
                    const extension = Filepath.split(".").pop();
                    if (extension) {
                        saveAs(new Blob([response.data]), `${filename}.${extension}`);
                    }
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        } else {
            this.SwalServices.Error("No data found");
        }
    };


    submit = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.itemObject;
            let requestData = {
                idItem: details.idItem,
                itemCode: details.itemCode,
                itemType: details.itemType, //details.types.find(x => x.value === details.itemTypeId)?.label,
                idItemCategory: details.idItemCategory,
                itemName: details.itemName,
                displayName: details.displayName,
                shortCode: details.shortCode,
                idUnit: details.idUnit,
                searchText: details.searchText,
                idMaterial: details.idMaterial,
                hsnCode: details.hsnCode,
                packingMaterial: "", //details.packingMaterial,
                opStock: details.openingStock,
                opStockDate: (details.openingStockDate && details.openingStockDate !== 'Invalid date') ? details.openingStockDate : null,
                currentStock: details.openingStock, //currentStock,
                drawingNo: details.drawingNo,
                minimumStock: details.minLevel,
                maximumStock: details.maxLevel,
                orderQty: details.orderQty,
                lockedQty: details.lockedQty,
                itemSize: details.idProductSize,
                drawingFile: details.drawingFile,
                itemRate: details.itemRate,
                stockRate: details.costingRate,
                purchaseRate: details.purchaseRate,
                weight: details.itemWeight,
                idTaxGroup: details.idTaxStructure,
                idCompany: this.state.idCompany,
                idCompanyDivision: 0,
                remarks: details.remarks,
                e_Date: details.eDate && details.eDate !== 'Invalid date' ? details.eDate : new Date().toISOString(),
                isUpdated: details.updateStatus === 1 ? true : details.isUpdated,
                updatedDate: details.updateStatus === 1 ? new Date().toISOString() : details.updatedDate,
                isDeleted: false,
                deletedDate: null,
                rateOn: details.rateOn,
                allowInventory: details.manage,
                idColor: 0,
                idItemGroup: details.itemGrpId,
                location: details.location,
                //type: details.types.find(x => x.value === details.selectedTypeId)?.label,
                // idItemGroup: details.idItemGroup,
                // itemGroup: details.itemGroupName,
                // itemGroupDesc: details.itemGroupDesc,
                //itemCategoryDesc: details.itemCategoryDesc,
                // remarks: details.remarks,
                // idCompany: this.state.idCompany,
                // idCompanyDivision: 0,
                // e_Date: details.eDate && details.eDate !== 'Invalid date' ? details.eDate : new Date().toISOString(),
                // isDeleted: false,
                // deletedDate: null
            };
            this.masterEntryServices.submitItemMaster(requestData)
                .then((response) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;
                        if (dynamicData !== null) {
                            if (dynamicData.errorType === 'Exists') {
                                this.SwalServices.Warning(dynamicData.errorMessage);
                            } else {
                                if (this.state.itemObject.updateStatus === 1) {
                                    this.SwalServices.Success("Updated successfully.");
                                } else {
                                    this.SwalServices.Success("Saved successfully.");
                                }
                                this.resetDetailsFields();
                                // Call resetFields here after submission
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.procSelectAllRecordsSP(); // Fetch latest records
                                    }
                                );
                            }
                        } else {
                            this.procSelectAllRecordsSP();
                        }
                    } else {
                        this.setState(
                            { isModalOpen: false },
                            () => {
                                this.SwalServices.Error(response.message);
                                this.procSelectAllRecordsSP(); // Fetch latest records
                            }
                        );
                    }
                });
        }
    };

    getItemMasterSelectbyID = (id) => {
        this.masterEntryServices.getItemMasterSelectbyID(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                let itemObject = this.state.itemObject;
                itemObject.idItem = res.idItem;
                itemObject.updateStatus = 1;
                itemObject.eDate = res.e_Date;
                itemObject.srNo = res.idItem;
                itemObject.itemCode = res.itemCode;
                itemObject.itemGrpId = res.idItemGroup;
                itemObject.itemType = res.itemType;
                //itemObject.itemTypeId = res.idIte;
                //itemObject.types = [],
                //itemObject.itemCategoryList = [];
                itemObject.idItemCategory = res.idItemCategory;
                itemObject.itemName = res.itemName;
                itemObject.displayName = res.displayName;
                itemObject.shortCode = res.shortCode;
                //itemObject.itemUnitList = [];
                itemObject.idUnit = res.idUnit;
                itemObject.searchText = res.searchText;
                //itemObject.materialList = [];
                itemObject.idMaterial = res.idMaterial;
                itemObject.hsnCode = res.hsnCode;
                //itemObject.itemSizeList = [];
                itemObject.idProductSize = res.itemSize;
                itemObject.openingStock = res.opStock;
                itemObject.openingStockDate = moment(res.opStockDate).format('YYYY-MM-DD');
                itemObject.currentStock = res.currentStock;
                itemObject.itemWeight = res.weight;
                itemObject.minLevel = res.minimumStock;
                itemObject.maxLevel = res.maximumStock;
                itemObject.orderQty = res.orderQty;
                itemObject.lockedQty = res.lockedQty;
                itemObject.itemRate = res.itemRate;
                itemObject.costingRate = res.stockRate;
                itemObject.purchaseRate = res.purchaseRate;
                itemObject.jobWorkRate = res.jobworkRate;
                //itemObject.taxStructureList = [];
                itemObject.idTaxStructure = res.idTaxGroup;
                itemObject.rateOn = res.rateOn;
                itemObject.drawingNo = res.drawingNo;
                itemObject.drawingFile = res.drawingFile;
                itemObject.location = res.location;
                itemObject.remarks = res.remarks;
                itemObject.manage = res.allowInventory;
                itemObject.isUpdated = res.isUpdated;
                itemObject.updatedDate = res.updatedDate;
                this.setState({
                    itemObject: itemObject,
                    isModalOpen: true
                }, () => {
                    this.filterItemCategoryList();
                    this.getMaster_ItemSelectForAutobyIdCategory()
                });
            }
        });
    }


    render() {
        return (
            <div className='tax-structure-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <ItemMasterPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            itemObject={this.state.itemObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            validState={this.state.validState}
                            onFileChange={this.onFileChange.bind(this)}
                            getFiles={this.getFiles.bind(this)}
                            handleChangeFroDropdown={this.handleChangeFroDropdown.bind(this)}
                            drawingFileRef={this.drawingFileRef}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Item master</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
